/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import ChatList from "./features/chatlist";

const ManageChat = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <ChatList />
        </section>
      </Layout>
    </>
  );
};
export default ManageChat;
